// extracted by mini-css-extract-plugin
export default {"container":"Benchmarking_container__vSWyy","title":"Benchmarking_title__9xpig","itemsColumn":"Benchmarking_itemsColumn__4s7TZ","surveyTitle":"Benchmarking_surveyTitle__JzWBE"};